(function () {
    'use strict';

    /*
     Category edit Controller
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.editAddress', [])
        .controller('UserAddressEditController', [
            '$scope',
            '__Form',
            'appServices',
            '__Utils',
            '$state',
            UserAddressEditController
        ]);

    /**
     * UserAddressEditController
     *
     * @inject $scope
     * @inject __Form
     * @inject appServices
     * @inject __Utils
     * @inject $state
     * 
     * @return void
     *-------------------------------------------------------- */

    function UserAddressEditController($scope, __Form, appServices, __Utils, $state) {

        var scope = this;

        scope = __Form.setup(scope, 'user_address_edit_form', 'addressData');

        scope.addressID = __globals.getAppJSItem('addressID');
        scope.loadSelectBox = false;
        scope.addressType = __globals.getAppJSItem('configGetAddressType');

        // Get all countries
        scope.countriesCollection = __globals.getAppJSItem('countries');
        scope.countries = scope.countriesCollection.data.countries;

        scope.countries_select_config = __globals.getSelectizeOptions({
            valueField: 'value',
            labelField: 'text',
            searchField: ['text']
        });

        if (_.isEmpty(scope.addressID)) {
            scope.addressData = $scope.ngDialogData.address;

            if (!_.isEmpty(scope.addressData)) {
                scope.loadSelectBox = true;
            };
            scope.addressID = scope.addressData.id;
            scope.getRoute = "";

        } else {
            scope.addressID = scope.addressData.id;
            scope = __Form.updateModel(scope, __globals.getAppJSItem('addressData'));
            scope.getRoute = __globals.getAppJSItem('getRoute');
        }

        /**
          * update form action
          *
          * @return void
          *------------------------------------------------------------------------ */

        scope.update = function () {

            scope.updateURL = {
                'apiURL': 'user.address.update',
                'addressID': scope.addressID
            };

            // post form data
            __Form.process(scope.updateURL, scope)
                .success(function (responseData) {
                    appServices.processResponse(responseData, function (reactionCode) {
                        if (reactionCode == 1) {
                            $scope.closeThisDialog({ address_updated: true, selectedAddressID: $scope.ngDialogData.selectedAddressID })
                        };

                    });

                });

        };

        /**
          * Close dialog and return promise object
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.close = function () {
            $scope.closeThisDialog({ address_updated: true, selectedAddressID: $scope.ngDialogData.selectedAddressID });
        }
    };
})();
